module.exports = __webpack_public_path__ + "img/tenet_icon_zun@2x.25d40edd.png";